module.exports = __webpack_public_path__ + "bf46c089da7d286fda6a927b205ddeb2.svg";